import { Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface Data {
  title: string;
}

interface Props {
  data: Data;
}
const TableCell = (props: Props) => {
  return <Typography.Text>{props.data?.title}</Typography.Text>;
};

export default observer(TableCell);
